module.exports = __webpack_public_path__ + "static/media/fss.1b6f3500.jpeg";